import _ from 'lodash'

export default class AlertsEngine {
  constructor (localStorage) {
    this.localStorage = localStorage
  }

  get shownAlerts () {
    return JSON.parse(this.localStorage.getItem('shownAlerts')) || []
  }

  hasBeenShown (alertId) {
    return _.includes(this.shownAlerts, alertId)
  }

  markAsShown (alertId) {
    const shownAlerts = this.shownAlerts

    this.localStorage.setItem(
      'shownAlerts',
      JSON.stringify(_.uniq([...shownAlerts, alertId]))
    )
  }
}
